module.exports = __webpack_public_path__ + "static/media/pink_green3.cb95036a.jpg";